
<template>
  <div class="sidebar">
    <SidebarHeader/>
    <div v-if="activeTab === 'Global'">
      <GlobalStyles />
    </div>
    <div v-if="activeTab === 'Media'">
      <AddMedia />
    </div>
    <div v-if="activeTab === 'Inspect'">
      <AddColumn v-if="isAddingComponent('ColumnsContainer')" :sharedData="componentData" :key="`Column-${componentData.id}`"/>
      <AddText v-else-if="isAddingComponent('Text')" :sharedData="componentData" :key="`Text-${componentData.id}`"/>
      <AddButton v-else-if="isAddingComponent('Button')" :sharedData="componentData" :key="`Button-${componentData.id}`"/>
      <AddDivider v-else-if="isAddingComponent('Divider')" :sharedData="componentData" :key="`Divider-${componentData.id}`"/>
      <AddContainer v-else-if="isAddingComponent('Container')" :sharedData="componentData" :key="`Container-${componentData.id}`"/>
      <AddHeading v-else-if="isAddingComponent('Heading')" :sharedData="componentData" :key="`Heading-${componentData.id}`"/>
      <AddImage v-else-if="isAddingComponent('Image')" :sharedData="componentData" :key="`Image-${componentData.id}`"/>
      <AddSpacer v-else-if="isAddingComponent('Spacer')" :sharedData="componentData" :key="`Spacer-${componentData.id}`"/>
      <AddHtml v-else-if="isAddingComponent('Html')" :sharedData="componentData" :key="`html-${componentData.id}`"/>
      <AddDynamic v-else-if="isAddingComponent('Dynamic')" :sharedData="componentData" :key="`dynamic-${componentData.id}`"/>
      <AddDynContainer v-else-if="isAddingComponent('DynContainer')" :sharedData="componentData" :key="`dynContainer-${componentData.id}`"/>
      <AddRuleset v-else-if="isAddingComponent('Ruleset')" :sharedData="componentData" :key="`rule-${componentData.id}`"/>
      <AddQr v-else-if="isAddingComponent('Qr')" :sharedData="componentData" :key="`qr-${componentData.id}`"/>
      <AddBlockFromDb v-else-if="isAddingComponent('Database')" :sharedData="componentData" />
      <AddBoilerplate v-else-if="isAddingComponent('Boilerplate')" :sharedData="componentData" />
      <div class="elseBlock" v-else> 
        {{ $t('Sidebar.Message') }}
        <br>
        <img class="imgEffect" src="../../public/CartagoBlock.png">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AddHeading from './Add/AddHeading.vue';
import AddHtml from './Add/AddHtml.vue';
import AddBoilerplate from './Add/AddBoilerplate.vue';
import AddText from './Add/AddText.vue';
import AddRuleset from './Add/AddRuleset.vue';
import AddSpacer from './Add/AddSpacer.vue';
import AddButton from './Add/AddButton.vue';
import AddContainer from './Add/AddContainer.vue';
import AddDynContainer from './Add/AddDynContainer.vue';
import AddColumn from './Add/AddColumn.vue';
import AddDivider from './Add/AddDivider.vue';
import AddImage from './Add/AddImage.vue';
import AddDynamic from './Add/AddDynamic.vue';
import AddMedia from './Add/AddMedia.vue';
import AddQr from './Add/AddQr.vue';
import AddBlockFromDb from './Add/AddBlockFromDb.vue';
import GlobalStyles from './Reusables/GlobalStyles.vue';
import SidebarHeader from './Reusables/SidebarHeader.vue';
import defaultData from '../../public/default.json';

export default {
  components: {
    AddHeading, AddText, AddContainer, GlobalStyles, AddHtml, AddBoilerplate, AddQr, AddDynamic, AddDynContainer,
    AddButton, AddDivider, AddColumn, AddImage, AddSpacer, SidebarHeader, AddMedia, AddRuleset, AddBlockFromDb
  },
  /* data() {
    return {
      activeTab: 'Inspect'
    };
  }, */
  computed: {
    ...mapState(['sharedData', 'add', 'activeTab']),
    componentData() {
      if (this.add) {
        return defaultData[this.add];
      }
      return this.sharedData; 
    }
  },
  methods: {
    isAddingComponent(type) {
      if (this.add) {
        return this.add === type;
      }
      return (this.sharedData && this.sharedData.type === type);
    }
  }
}
</script>

<style scoped>
.sidebar {
  background: white;
  min-height: 100vh;
}

.elseBlock {
  margin-top: 40px;
  font-family: 'Montserrat', sans-serif;
}

img {
  height: 30px;
  margin: 10px;
}

.imgEffect {
  
  animation: imgEffect 3s ease infinite;
}

@keyframes imgEffect {
  30% { transform: scale(1.2); }
  40%, 60% { transform: rotate(-20deg) scale(1.2); }
  50% { transform: rotate(20deg) scale(1.2); }
  70% { transform: rotate(0deg) scale(1.2); }
  100% { transform: scale(1); }
}
</style>

